import * as React from 'react';

interface Props {
  ariaName?: string;
  width?: number;
  height?: number;
}

export const QuestionMark: React.FunctionComponent<Props> = ({
  ariaName,
  width = 16,
  height = 16,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{ariaName}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 1.75C4.54822 1.75 1.75 4.54822 1.75 8C1.75 11.4518 4.54822 14.25 8 14.25C11.4518 14.25 14.25 11.4518 14.25 8C14.25 4.54822 11.4518 1.75 8 1.75ZM0.25 8C0.25 3.71979 3.71979 0.25 8 0.25C12.2802 0.25 15.75 3.71979 15.75 8C15.75 12.2802 12.2802 15.75 8 15.75C3.71979 15.75 0.25 12.2802 0.25 8Z"
        fill="#767676"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.94762 3.70933C7.45012 3.50119 8.00305 3.44673 8.5365 3.55284C9.06995 3.65895 9.55995 3.92086 9.94454 4.30546C10.3291 4.69005 10.5911 5.18006 10.6972 5.7135C10.8033 6.24695 10.7488 6.79988 10.5407 7.30238C10.3325 7.80488 9.98005 8.23437 9.52782 8.53654C9.2876 8.69705 9.02497 8.81781 8.75 8.89575V10H7.25V7.5H8C8.24723 7.5 8.4889 7.42669 8.69446 7.28934C8.90002 7.15199 9.06024 6.95676 9.15485 6.72836C9.24946 6.49995 9.27421 6.24861 9.22598 6.00614C9.17775 5.76366 9.0587 5.54093 8.88388 5.36612C8.70907 5.1913 8.48634 5.07225 8.24386 5.02402C8.00139 4.97579 7.75005 5.00054 7.52165 5.09515C7.29324 5.18976 7.09801 5.34998 6.96066 5.55554C6.82331 5.7611 6.75 6.00277 6.75 6.25H5.25C5.25 5.7061 5.41128 5.17442 5.71346 4.72218C6.01563 4.26995 6.44512 3.91747 6.94762 3.70933ZM8.75 12.5V11H7.25V12.5H8.75Z"
        fill="#767676"
      />
    </svg>
  );
};
